import React from "react";
import { StaticQuery, graphql } from "gatsby";
import PropTypes from "prop-types";
import { useRecoilState } from "recoil";

import { previewDataState } from "src/recoil/atoms";
import Box from "src/components/UI/Structure/Box";
import Button from "src/components/UI/Button";
import Contact from "src/components/Modules/Contact";

const ArtistAgent = ({ data, agent, label, english, artist, customRole }) => {
  // Set gatsby data
  const gatsbyContact = data.allWpStaff.edges
    .filter(({ node: staff }) => staff.databaseId === agent.databaseId)
    .map(({ node: staff }) => {
      return {
        name: staff.title,
        role: customRole ? customRole : staff.acfStaffPage.role,
        mail: staff.acfStaffPage.mail,
        phoneNumbers: staff.acfStaffPage.phoneNumbers,
      };
    })[0];

  // Get preview data
  const [previewData] = useRecoilState(previewDataState);
  const { staffs } = previewData;

  // Set preview data if fetched
  const previewContact =
    staffs.length > 0
      ? staffs.filter((staff) => {
          return staff.databaseId === agent.databaseId;
        })[0]
      : null;

  // Choose data based on gatsby or preview mode
  const contact = previewContact
    ? previewContact
    : gatsbyContact
    ? gatsbyContact
    : null;

  return contact ? (
    <React.Fragment>
      <Contact
        label={label}
        contact={contact}
        alignBottom={false}
        fontSize={[2, null, null, null, 4, 5]}
      />
      <Box mt={[5, null, null, null, 10]}>
        <Button
          label={english ? "Booking" : "Bokningsförfrågan"}
          size="large"
          filled="dark"
          link={`mailto:${contact.mail}?subject=${
            english
              ? "Booking request regarding "
              : "Bokningsförfrågan gällande "
          }${artist}`}
          target="_blank"
        >
          {english ? "Booking" : "Bokningsförfrågan"}
        </Button>
      </Box>
    </React.Fragment>
  ) : null;
};

export default (props) => (
  <StaticQuery
    query={graphql`
      query {
        allWpStaff {
          edges {
            node {
              databaseId
              title
              acfStaffPage {
                role
                mail
                phoneNumbers {
                  number
                }
              }
            }
          }
        }
      }
    `}
    render={(data) => <ArtistAgent data={data} {...props} />}
  />
);

ArtistAgent.propTypes = {
  data: PropTypes.shape({
    allWpStaff: PropTypes.shape({
      edges: PropTypes.arrayOf(
        PropTypes.shape({
          node: PropTypes.shape({
            databaseId: PropTypes.number.isRequired,
            title: PropTypes.string.isRequired,
            acfStaffPage: PropTypes.shape({
              role: PropTypes.string,
              mail: PropTypes.string,
              phoneNumbers: PropTypes.arrayOf(
                PropTypes.shape({
                  number: PropTypes.string.isRequired,
                }).isRequired
              ).isRequired,
            }),
          }).isRequired,
        }).isRequired
      ).isRequired,
    }).isRequired,
  }).isRequired,
};
